<div class="wrapper flex flex-col gap-[40px]">
  <div class="heading text-type-2">Activity</div>
  <app-text-area
    [parentFormGroup]="form"
    controlName="title"
    label="detail"
    />
  @if (pictures?.length) {
    <app-pictures-section
      (onDelete)="deletePicture($event)"
      [isEditable]="false"
      [pictures]="pictures"
      class="pictures-section mb-[40px]"
      />
  }
  @if (showLocationSection()) {
    <app-location-section
      (onDelete)="deleteLocation()"
      [isEditable]="false"
      [latitude]="form?.controls?.latitude?.value"
      [longitude]="form?.controls?.longitude?.value"
      class="location-section mb-[40px]"
      />
  }
</div>
